"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const mediaQuery_1 = require("../../cssMixins/mediaQuery");
const DescriptionHeader_1 = __importDefault(require("../../molecules/DescriptionHeader"));
const styled_components_1 = __importStar(require("styled-components"));
function DescriptionPanel({ onClose, descriptionText, closeDescriptionButtonRef, }) {
    const { t } = (0, i18n_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsx)(DescriptionHeader_1.default, { closeDescriptionButtonRef: closeDescriptionButtonRef, titleText: t(i18n_1.Strings.toolbar.screenDescription), onClose: onClose, icon: ui_1.Icons.Close }), (0, jsx_runtime_1.jsx)(ui_1.InfoContainer, { descriptionText: descriptionText })] }));
}
const Container = styled_components_1.default.div `
  position: absolute;
  top: 64px;
  left: 8px;
  width: 400px;
  min-height: 100px;
  max-height: calc(100vh - 64px - 32px);
  padding: 16px 8px;

  display: flex;
  flex-direction: column;
  border-radius: 4px;

  z-index: 13;

  background: ${props => props.theme.grasshopper.descriptionPanel.background};
  color: ${props => props.theme.white};
  pointer-events: all;

  ${mediaQuery_1.device.tablet((0, styled_components_1.css) `
    width: 100%;
    bottom: 0;
    left: 0;
    top: auto;
    max-height: 40vh;
    border-radius: 0px;
    box-sizing: border-box;
  `)};

  ${mediaQuery_1.deviceLandscape.mobile((0, styled_components_1.css) `
    max-height: 100vh;
  `)};
`;
exports.default = DescriptionPanel;
